import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Grid,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { editGuestDetail, getSalesOrderDetail, returnUpdate } from "../actions";
import Header from "../Components/header";
import NavigationButtons from "../Components/navigationButton";
import SectionForm from "../Components/sectionForm";
import CustomRadioButton from "../Components/customRadio";
import { getPicklist, isDifferentValue } from "../util/helpers";
import Swal from "sweetalert2";
import YearPicker from "../../../components/global/InputDate/yearPicker";
import { withTranslation } from "react-i18next";

const { URL_PREFIX } = window;

class VF2Step2 extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      isGetDataLoading: false,
      isOpen: false,
      form: {
        selectedActivity: 'snorkelling',
        Snorkeler_Description__c: '', 
        Snorkling_Style__c: '', 
        Snorkeling_Equipment_Rental__c: '', 
        Dive_Style__c: '', 
        Number_of_Dives__c: '', 
        Diving_Start_Year__c: '', 
        No_of_days_diving_per_year__c: '', 
        Certification_Agency__c: '', 
        Certification_Level__c: '', 
        Certification_Number__c: '', 
        Nitrox_Agency__c: '', 
        Nitrox_Certificate__c: '', 
        Diving_Insurance_Agency__c: '', 
        Diving_Insurance_Number__c: '', 
        Tank_size__c: '', 
        Underwater_Camera__c: '', 
        Last_Dive__c: '', 
        Diving_Equipment_Rental__c: '', 
        Nitrox_Requested__c: 'yes',
      },
    };
  }

  componentDidMount() {
    const { guestDetail } = this.props.vf2;

    const selectedActivity = 
        guestDetail.Snorkeling_Package__c && guestDetail.Diving_Package__c
          ? 'both'
          : guestDetail.Snorkeling_Package__c
          ? 'snorkelling'
          : guestDetail.Diving_Package__c
          ? 'diving'
          : '';

    if (guestDetail) {
      this.setState({
        form: {
          selectedActivity, // or set from guestDetail if available
          Snorkeler_Description__c: guestDetail.Snorkeler_Description__c ?? '',
          Snorkling_Style__c: guestDetail.Snorkling_Style__c ?? '',
          Snorkeling_Equipment_Rental__c: guestDetail.Snorkeling_Equipment_Rental__c ?? '',
          Dive_Style__c: guestDetail.Dive_Style__c ?? '',
          Number_of_Dives__c: guestDetail.Number_of_Dives__c ?? '',
          Diving_Start_Year__c: guestDetail.Diving_Start_Year__c ?? '',
          No_of_days_diving_per_year__c: guestDetail.No_of_days_diving_per_year__c ?? '',
          Certification_Agency__c: guestDetail.Certification_Agency__c ?? '',
          Certification_Level__c: guestDetail.Certification_Level__c ?? '',
          Certification_Number__c: guestDetail.Certification_Number__c ?? '',
          Nitrox_Agency__c: guestDetail.Nitrox_Agency__c ?? '',
          Nitrox_Certificate__c: guestDetail.Nitrox_Certificate__c ?? '',
          Diving_Insurance_Agency__c: guestDetail.Diving_Insurance_Agency__c ?? '',
          Diving_Insurance_Number__c: guestDetail.Diving_Insurance_Number__c ?? '',
          Tank_size__c: guestDetail.Tank_size__c ?? '',
          Underwater_Camera__c: guestDetail.Underwater_Camera__c ?? '',
          Last_Dive__c: guestDetail.Last_Dive__c
            ? String(guestDetail.Last_Dive__c).length === 4
              ? new Date(`${guestDetail.Last_Dive__c}-01-01`)
              : new Date(guestDetail.Last_Dive__c)
            : null,
          Diving_Equipment_Rental__c: guestDetail.Diving_Equipment_Rental__c ?? '',
          Nitrox_Requested__c: guestDetail.Nitrox_Requested__c ? 'yes' : 'no',
        },
      });
    }
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [name]: value,
      },
    }));
  };

  handleSave = async() => {
    let payload = {...this.state.form};
    const selectedActivity = payload.selectedActivity
    delete payload.selectedActivity

    payload.Nitrox_Requested__c = payload.Nitrox_Requested__c === 'yes'
    payload.Snorkeling_Package__c = ['snorkelling', 'both'].includes(selectedActivity)
    payload.Diving_Package__c = ['diving', 'both'].includes(selectedActivity)
    if (payload.Last_Dive__c) {
      const date = new Date(payload.Last_Dive__c);
      payload.Last_Dive__c = date.getFullYear();
    }

    this.setState({ isLoading: true });
    try {
      const {guestDetail} = this.props.vf2
      if(isDifferentValue(payload, guestDetail)){
        await this.props.editGuestDetail(payload, guestDetail.Id, this.props.returnUpdate, 'detail');
      }
    } catch (error) {
      let errorMessage = this.props.t("An unknown error occurred");
      if (error.response) {
        errorMessage = error.response.message || "Login failed"; // Server error
      } else if (error.message) {
        errorMessage = error.message; // Client-side or network error
      }
      Swal.fire({
        type: "error",
        title: "Oops...",
        text: `${this.props.t("Something went wrong!")} ${errorMessage}`,
      });
      return false
    } finally {
      this.setState({ isLoading: false });
    }
  };

  componentWillMount() {
  }

  render() {
    const { describe, guestDetail, agentDetail } = this.props.vf2;
    const { form } = this.state;


    return (
      <>
        <div style={{ margin: "30px", position:'relative' }}>
          <Header 
            title={this.props.t("Snorkelling / Diving Preferences" )}
            subtitle={this.props.t("Tell us about your snorkelling / diving skills and preferences" )}
            selectedGuest={guestDetail}
            agent={agentDetail}
          />
          
          <SectionForm title={this.props.t("Activity Package")} subtitle={this.props.t("Select your activity to see the relevant questions.")}>
            <Grid container spacing={2} sx={{ padding: '10px 0' }}>
              <Grid item xs={12}>
                <Typography variant="body1" sx={{ marginBottom: '8px' }}>
                  &nbsp;
                </Typography>
                <div style={{ position: 'relative' }}>
                  <CustomRadioButton
                    label={this.props.t("Snorkelling")}
                    value="snorkelling"
                    name="selectedActivity"
                    checked={form.selectedActivity === "snorkelling"}
                    onChange={this.handleChange} 
                  />
                  <CustomRadioButton
                    label={this.props.t("Diving")}
                    value="diving"
                    name="selectedActivity"
                    checked={form.selectedActivity === "diving"}
                    onChange={this.handleChange} 
                  />
                  <CustomRadioButton
                    label={this.props.t("Both")}
                    value="both"
                    name="selectedActivity"
                    checked={form.selectedActivity === "both"}
                    onChange={this.handleChange} 
                  />
                </div>
              </Grid>
            </Grid>
          </SectionForm>

          {['snorkelling', 'both'].includes(form.selectedActivity) &&
          <SectionForm title={this.props.t("Snorkelling")} subtitle={this.props.t("Tell us about your snorkelling experiences")}>
            <Grid container spacing={2} sx={{ padding: '10px 0' }}>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {this.props.t("How do you describe yourself as a snorkeller?")}
                </Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    labelId="snorkeller-description-label"
                    name="Snorkeler_Description__c"
                    value={form.Snorkeler_Description__c || ''}
                    onChange={this.handleChange}
                    variant="outlined"
                    sx={{ marginTop: 0 }}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>{this.props.t("Please select")}</MenuItem>
                    {getPicklist('Snorkeler_Description__c', describe).map((value,i) => 
                      <MenuItem value={value} key={i}>{this.props.t(value)}</MenuItem>  
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {this.props.t("How would you describe your snorkelling style?")}
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={5}
                  placeholder={`${this.props.t("Enter a description")}..`}
                  name="Snorkling_Style__c"
                  value={form.Snorkling_Style__c}
                  onChange={this.handleChange}
                />
                <Typography variant="body1" sx={{ color: '#667085', fontWeight: 300 }}>
                  ({this.props.t("Any preferences or requirements that you may have")})
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {this.props.t("What equipment would you like to rent, if any?")}
                </Typography>
                <TextField
                  variant="outlined"
                  placeholder={`${this.props.t("Enter a description")}..`}
                  fullWidth
                  multiline
                  rows={5}
                  name="Snorkeling_Equipment_Rental__c"
                  value={form.Snorkeling_Equipment_Rental__c}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </SectionForm>
          }

          {['diving', 'both'].includes(form.selectedActivity) &&
          <SectionForm title={this.props.t("Diving")} subtitle={this.props.t("Tell us about your diving experiences")}>
            <Grid container spacing={2} sx={{ padding: '10px 0' }}>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {this.props.t("How would you describe your diving style?")}
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={5}
                  placeholder={`${this.props.t("Enter a description")}..`}
                  name="Dive_Style__c"
                  value={form.Dive_Style__c}
                  onChange={this.handleChange}
                />
                <Typography variant="body1" sx={{ color: '#667085', fontWeight: 300 }}>
                  ({this.props.t("Any preferences or requirements that you may have")})
                </Typography>
              </Grid>

              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Number of Dives")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="Number"
                  placeholder="number"
                  name="Number_of_Dives__c"
                  value={form.Number_of_Dives__c}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("What year did you start diving?")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="Year"
                  type="number"
                  name="Diving_Start_Year__c"
                  value={form.Diving_Start_Year__c}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("How many dives on average per year?")}</Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    labelId="average-dives-label"
                    name="No_of_days_diving_per_year__c"
                    value={form.No_of_days_diving_per_year__c}
                    onChange={this.handleChange}
                    variant="outlined"
                    sx={{ marginTop: 0 }}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>{this.props.t("Select average")}</MenuItem>
                    {getPicklist('No_of_days_diving_per_year__c', describe).map((value,i) => 
                      <MenuItem value={value} key={i}>{value}</MenuItem>  
                    )}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Certification Agency")}</Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    labelId="certification-agency-label"
                    name="Certification_Agency__c"
                    value={form.Certification_Agency__c}
                    onChange={this.handleChange}
                    variant="outlined"
                    sx={{ marginTop: 0 }}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>{this.props.t('Select Agency')}</MenuItem>
                    {getPicklist('Certification_Agency__c', describe).map((value,i) => 
                      <MenuItem value={value} key={i}>{value}</MenuItem>  
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Certification Level")}</Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    labelId="certification-level-label"
                    name="Certification_Level__c"
                    value={form.Certification_Level__c}
                    onChange={this.handleChange}
                    variant="outlined"
                    sx={{ marginTop: 0 }}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>{this.props.t("Select Level")}</MenuItem>
                    {getPicklist('Certification_Level__c', describe).map((value,i) => 
                      <MenuItem value={value} key={i}>{value}</MenuItem>  
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="body1">{this.props.t("Certification Number")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="number"
                  type="text"
                  name="Certification_Number__c"
                  value={form.Certification_Number__c}
                  onChange={this.handleChange}
                />
              </Grid>

              

              <Grid item xs={6}>
                <Typography variant="body1" sx={{ marginBottom: '8px' }}>
                  {this.props.t("Nitrox Requested?")}
                </Typography>
                <div>
                  <CustomRadioButton
                    label={this.props.t("Yes")}
                    value="yes"
                    name="Nitrox_Requested__c"
                    checked={form.Nitrox_Requested__c === "yes"}
                    onChange={this.handleChange}
                  />
                  <CustomRadioButton
                    label={this.props.t("No")}
                    name="Nitrox_Requested__c"
                    value="no"
                    checked={form.Nitrox_Requested__c === "no"}
                    onChange={this.handleChange}
                  />
                </div>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t("Desired Tank Size")}</Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    labelId="tank-size-label"
                    name="Tank_size__c"
                    value={form.Tank_size__c}
                    onChange={this.handleChange}
                    variant="outlined"
                    sx={{ marginTop: 0 }}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>{this.props.t("Select Size")}</MenuItem>
                    {getPicklist('Tank_size__c', describe).map((value,i) => 
                      <MenuItem value={value} key={i}>{value}</MenuItem>  
                    )}
                  </Select>
                </FormControl>
              </Grid>
              {
                form.Nitrox_Requested__c === 'yes' &&
              <>
                <Grid item xs={6}>
                  <Typography variant="body1">{this.props.t("Nitrox Agency")}</Typography>
                  <FormControl variant="outlined" fullWidth>
                    <Select
                      labelId="nitrox-agency-label"
                      name="Nitrox_Agency__c"
                      value={form.Nitrox_Agency__c}
                      onChange={this.handleChange}
                      variant="outlined"
                      sx={{ marginTop: 0 }}
                      displayEmpty
                      defaultValue=""
                    >
                      <MenuItem value="" disabled>{this.props.t("Select Agency")}</MenuItem>
                      {getPicklist('Nitrox_Agency__c', describe).map((value,i) => 
                        <MenuItem value={value} key={i}>{value}</MenuItem>  
                      )}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="body1">{this.props.t("Nitrox Certification Number")}</Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Number"
                    type="text"
                    name="Nitrox_Certificate__c"
                    value={form.Nitrox_Certificate__c}
                    onChange={this.handleChange}
                  />
                </Grid>
              </>
              }

              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t('Diving Insurance Agency')}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="Agency"
                  type="text"
                  name="Diving_Insurance_Agency__c"
                  value={form.Diving_Insurance_Agency__c}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t("Diving Insurance Number")}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="text"
                  placeholder="Number"
                  name="Diving_Insurance_Number__c"
                  value={form.Diving_Insurance_Number__c}
                  onChange={this.handleChange}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t("What underwater camera do you use?")}</Typography>
                <FormControl variant="outlined" fullWidth>
                  <Select
                    labelId="underwater-camera-label"
                    name="Underwater_Camera__c"
                    value={form.Underwater_Camera__c}
                    onChange={this.handleChange}
                    variant="outlined"
                    sx={{ marginTop: 0 }}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem value="" disabled>{this.props.t("Select Camera")}</MenuItem>
                    {getPicklist('Underwater_Camera__c', describe).map((value,i) => 
                      <MenuItem value={value} key={i}>{value}</MenuItem>  
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{this.props.t("When was your last dive?")}</Typography>
                <YearPicker 
                  value={form.Last_Dive__c}
                  name="Last_Dive__c"
                  handleChange={this.handleChange}/>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1">{this.props.t('What equipment would you like to rent, if any?')}</Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={5}
                  placeholder={`${this.props.t("Enter a description")}..`}
                  name="Diving_Equipment_Rental__c"
                  value={form.Diving_Equipment_Rental__c}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </SectionForm>
          }

          <NavigationButtons 
            nextUrl={`${URL_PREFIX}/vf2/wizard/stay`} 
            backUrl={this.props.mainContact ? `${URL_PREFIX}/vf2/wizard/personal` : `${URL_PREFIX}/vf2/wizard`} 
            onSave={this.handleSave} 
            isLoading={this.state.isLoading} 
            showSave
            showBack
            showNext // Change to false to hide the Next button
          />
         
        </div >

      </>
    );
  }
}

VF2Step2.propTypes = {
  vf2: PropTypes.object.isRequired,
  // nextStep: PropTypes.func.isRequired,
  // previousStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      editGuestDetail,
      getSalesOrderDetail,
      returnUpdate
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  vf2: state.vf2,
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VF2Step2));
